import { render, staticRenderFns } from "./salesPolicyPC.vue?vue&type=template&id=0aa070e2&scoped=true"
import script from "./salesPolicyPC.vue?vue&type=script&lang=js"
export * from "./salesPolicyPC.vue?vue&type=script&lang=js"
import style0 from "./salesPolicyPC.vue?vue&type=style&index=0&id=0aa070e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa070e2",
  null
  
)

export default component.exports